import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { LanguagesControllerApi } from "../services";
import { getConfigObject, useBaseContent } from "../utils/utils";

export type OptionData = {
  name: string;
  uuid: string;
};

interface Props {
  xTENANTID: string | undefined | null;
  enabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */
export const useLanguageList = ({
  xTENANTID,
  enabled,
}: Props): useBaseContent<OptionData> =>
  useQuery({
    queryKey: ["language-list", xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled ?? true,
    queryFn: async () => {
      const api = new LanguagesControllerApi(getConfigObject());
      const response = await api.getAllLanguages(
        0, // page
        100, // size
        undefined, // sortBy
        undefined, // sortDirection
        xTENANTID as any //xTENANTID
      );
      return response?.data;
    },
  });
